/**
 * Shared interaction treatment for controls that disclose another surface.
 * Temporary hover/focus feedback is neutral; the persistent open state uses the
 * same accent treatment as a current sidebar destination.
 */
export const disclosureTriggerInteractionClassName =
  'enabled:hover:bg-interaction-neutral enabled:hover:text-foreground focus-visible:bg-interaction-neutral focus-visible:text-foreground data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-primary data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-primary data-[state=open]:focus-visible:bg-sidebar-accent data-[state=open]:focus-visible:text-sidebar-primary transition-colors motion-reduce:transition-none'

export const dropdownTriggerInteractionClassName = disclosureTriggerInteractionClassName
